import { PIQ_SESSION_TOKEN_KEY } from '../../../components/trustlyIframe/trustlyUtils';
import { TDynamicStoreField } from '../../../store/store';
import { Limit, MarketingConsent } from '../../../types/types';
import { COOKIE_NAMES } from '../../../utils/constants';
import { getCookieByName } from '../../../utils/cookies';
import { currentCountryMarketInfo } from '../../../utils/countries';
import { gatekeeper } from '../../../utils/gatekeeper';
import { getDepositLimitData } from '../../../utils/utils';

export class PNP_MGA_GRA {
  email: string;
  plainTextPassword: string;
  phonePrefix: string;
  phoneNumber: string;
  phoneVerified: boolean;
  nationality: string;
  welcomeOfferId?: string;
  sessionToken?: string;
  trackingId: string;
  marketCode: string;
  subscribeToMarketingMaterial: boolean;
  marketingConsent: MarketingConsent;
  limit: Limit | null;

  constructor(data: TDynamicStoreField | null) {
    if (!data) throw new Error('Data is required to instantiate PNP_MGA_GRA.');

    const countryInfo = currentCountryMarketInfo(gatekeeper?.localisation?.marketSlug);

    this.email = data.email?.trim();
    this.plainTextPassword = data.plainTextPassword?.trim();
    this.phonePrefix = data.phonePrefix;
    this.phoneNumber = data.phoneNumber?.trim();
    this.phoneVerified = false;
    this.nationality = data.nationality?.trim();
    this.welcomeOfferId = data.welcomeOffer;
    this.sessionToken = sessionStorage.getItem(PIQ_SESSION_TOKEN_KEY) ?? data.sessionToken;
    this.trackingId = getCookieByName(COOKIE_NAMES.KAZUMO_TRACKING_ID) ?? '';
    this.marketCode = countryInfo?.marketCode ?? '';
    this.subscribeToMarketingMaterial = data.subscribeToMarketingMaterial ?? false;
    this.marketingConsent = data.marketingConsent ?? false;
    this.limit = getDepositLimitData(data.daily, data.weekly, data.monthly, countryInfo?.currency ?? 'EUR');
  }

  get data() {
    return { ...this };
  }
}
